export const toError = value =>
  value instanceof Error ? value : new Error(String(value));
